export default __webpack_public_path__ + "static/media/img7.463deec9.png";